// extracted by mini-css-extract-plugin
export default {"transactionContainer":"styles_transactionContainer__bUeSY","label":"styles_label__Zrlyv","switch":"styles_switch__Cbn6q"};